/* eslint-disable react/prop-types */
import React, { useContext, useEffect, useState } from "react";
import { UsuarioContext } from "config/context/UsuarioProvider";
import { Iframe } from "./iframe/iframe";

// *** core components
import GridContainer from "components/Grid/GridContainer.js";
import MuiAlert from "@material-ui/lab/Alert";
import GridItem from "components/Grid/GridItem.js";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Snackbar from "@material-ui/core/Snackbar";
import { SessionActions } from "services";
// *** @material-ui/core components
import { makeStyles, withStyles } from "@material-ui/core/styles";

// *** Imagenes
import imgContratoFea from "assets/img/com-fea/img-contrato.png";
import imgContrato from "assets/img/com-fes/img-contrato.png";
import featuresStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/featuresStyle.js";

const useStyles2 = makeStyles(featuresStyle);
const styles = {
  root: {
    "&.MuiCheckbox-colorSecondary.Mui-checked": {
      color: "#a1c330",
    },
  },
};

const GreenCheckbox = withStyles(styles)(Checkbox);

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function ContratoAdhesion({ setbtnDisable }) {
  const { planUser, usuario } = useContext(UsuarioContext);
  const classes2 = useStyles2();

  const [checked, setChecked] = useState(false);
  const [showError, setShowError] = useState(false);
  const [contract, setContract] = useState(null);

  useEffect(() => {
    async function getContract() {
      const res = await SessionActions.getContract(usuario.token);
      if (!res.success) {
        setShowError(true);
      } else {
        setContract(res.payload.contratoUrl);
      }
    }
    getContract();
  }, []);

  useEffect(() => {
    setbtnDisable(!checked);
  }, [checked, setChecked]);

  return (
    <div>
      <Snackbar
        open={showError}
        onClose={() => setShowError(false)}
        autoHideDuration={9000}
      >
        <Alert severity="error">
          <b>ERROR:</b> Ha ocurrido un error. Intente nuevamente o contáctenos.
        </Alert>
      </Snackbar>
      <GridContainer>
        <GridItem xs={12} sm={12} md={6}>
          <div className={classes2.features3}>
            {planUser === "CFES" ? (
              <img src={imgContrato} alt="..." />
            ) : (
              <img src={imgContratoFea} alt="..." />
            )}
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <div
                style={{
                  marginTop: 60,
                  textAlign: "center",
                }}
              >
                <h3 style={{ fontWeight: "bolder" }}>Contrato de Adhesión</h3>
              </div>
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <div
                style={{
                  minHeight: 400,
                }}
              >
                <Iframe source={contract} />
              </div>
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <div>
                <FormControlLabel
                  control={
                    <GreenCheckbox
                      tabIndex={-1}
                      onClick={() => {
                        setChecked(!checked);
                      }}
                      checked={checked}
                    />
                  }
                  classes={{ label: classes2.label, root: classes2.labelRoot }}
                  label="Debe aceptar los términos y condiciones del contrato para continuar."
                />
              </div>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    </div>
  );
}
